const { Type } = require('@sinclair/typebox');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');

/** Builds the TypeBox schema fragment for the Integer form element. */
function asDataDictionary(hNode, context) {
    const { id, title, propertyName, min, max, required, defaultValue } = hNode;
    //This block tells us nothing about namespaces/relations
    const subDataDictionary = {};

    // reuse consistent flags
    const { isRequired, isEditable, isOptional, forAction } = moduleRegistration.resolveFieldFlags(required, context);
    const maybeOptional = schema => (isOptional ? Type.Optional(schema) : schema);

    // Build the integer schema with constraints
    const integerOptions = {
        title: title,
        'x-id': id,
        'x-dataType': 'integer',
        'x-propertyName': propertyName,
        'x-required': isRequired,
        'x-optional': isOptional,
        'x-editable': isEditable
    };

    // Add forAction annotation if this field is within a DetailPane with a specific action
    if (forAction) {
        integerOptions['x-forAction'] = forAction;
    }

    // Add min/max constraints if provided
    if (min !== undefined && min !== null) {
        integerOptions.minimum = min;
    }
    if (max !== undefined && max !== null) {
        integerOptions.maximum = max;
    }
    if (defaultValue !== undefined && defaultValue !== null) {
        integerOptions.default = defaultValue;
    }

    const integerSchema = maybeOptional(Type.Integer(integerOptions));

    // The partial type definition is a plain object with the property schema
    const partialTypeDefinition = {
        [propertyName]: integerSchema
    };

    return [subDataDictionary, partialTypeDefinition];
}

module.exports = { asDataDictionary };
